import { setBuilderToolbar } from '../../../../../Template/config/components/selection/SetBuilder';

export default {
  ...setBuilderToolbar,
  enableExcludeNonNormFilters: {
    ad: false,
    norm: false
  },
  exportButtons: {
    ad: {
      data: true,
      media: true
    },
    norm: {
      data: true,
      media: true
    }
  },
  sortOptions: [
    {
      "value": -1,
      "label": "Alpha Order by Brand",
      "field": "brand",
      "selected": false
    },
    {
      "value": 1,
      "label": "Total Ad Awareness",
      "selected": true,
      "dataFormat": "%,1"
    },

    {
      "value": 2,
      "label": "Brand Linkage",
      "selected": false
    },
    {
      "value": 3,
      "label": "Branded Ad Awareness",
      "selected": false,
    },
    {
      "value": 6,
      "label": "Ad Appeal",
      "selected": false
    },
    {
      "value": 122,
      "label": "Lift to Brand Impression",
      "selected": false
    },
    {
      "value": 121,
      "label": "Lift to Consideration",
      "selected": false
    },
    
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/components/selection/SetBuilder/setBuilderToolbar.js